import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from '../services/log.service';

/**
 * Global Error Handler
 * Catches all unhandled errors in the Angular application and routes them to the LogService
 * This provides centralized error logging with OpenTelemetry integration
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private logService: LogService) {}

    handleError(error: any): void {
        // Extract meaningful error information
        const message = this.extractMessage(error);
        const stackTrace = error.stack || '';

        // Log to our centralized logging service
        this.logService.error(message, {
            error: error.message || error.toString(),
            stackTrace: stackTrace,
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        });

        // Re-throw the error for Angular's default error handling
        // This prevents the application from continuing in an invalid state
        if (error instanceof Error) {
            throw error;
        }
    }

    private extractMessage(error: any): string {
        if (typeof error === 'string') {
            return error;
        }

        if (error?.message) {
            return error.message;
        }

        if (error?.error?.message) {
            return error.error.message;
        }

        if (error?.statusText) {
            return `HTTP Error: ${error.status} - ${error.statusText}`;
        }

        return 'An unexpected error occurred';
    }
}
